/* global window */
'use strict';

module.exports = {
    get: function () {
        // Behavior matching that of Dove's "categorizr"
        var device = 'desktop',
            screen = window.top && window.top.screen ? window.top.screen : {},
            navigator = window.navigator || {};
        if ('ontouchstart' in window || navigator.MaxTouchPoints > 0 || navigator.msMaxTouchPoints > 0) {
            if (
                (screen.width >= 1024 && screen.height >= 768) ||
                (screen.height >= 1024 && screen.width >= 768)
            ) {
                device = 'tablet';
            } else {
                device = 'mobile';
            }
        }
        return device;
    },
};
